// extracted by css-extract-rspack-plugin
export default {"main":"rLxEjfSuBmw1VBgT","error":"o1bOAkSMtgY5Btx3","tokenInput":"aG1nyd1PAo4ohSzt"};